import { createSelector } from "@reduxjs/toolkit";
import { rootState } from "../../../../redux/store";

//     const {commitsLoading} = useAppSelector((state: rootState) => state.commits);


export const selectorConfigurationRoot = createSelector(
    (state: rootState) => state.webSocket,
    (state: rootState) => state.project,
    (state: rootState) => state.loginUserAndTokenData,
    (state: rootState) => state.userSettingsAllFilePath,
    (state: rootState) => state.userSettingsProjectPath,
    (state: rootState) => state.mergingAvatar,
    (state: rootState) => state.createAndSendPassengers,
    (state: rootState) => state.stagingList,
    (state: rootState) => state.hostAndUsername,
    (state: rootState) => state.savedUserToken,
    (state: rootState) => state.defaultProjectPath,
    (state: rootState) => state.departments,
    (state: rootState) => state.featuresConfig,
    (state: rootState) => state.status,
    (state: rootState) => state.commits,
    (state: rootState) => state.trigger,


    (
        webSocket, 
        project, 
        loginUserAndTokenData, 
        userSettingsAllFilePath, 
        userSettingsProjectPath, 
        mergingAvatar, 
        createAndSendPassengers, 
        stagingList, 
        hostAndUsername,
        savedUserToken,
        defaultProjectPath,
        departments,
        featuresConfig,
        status,
        commits,
        trigger
    ) => {
        return  {
            webSocket,
            project,
            loginUserAndTokenData,
            userSettingsAllFilePath, 
            userSettingsProjectPath, 
            mergingAvatar, 
            createAndSendPassengers, 
            stagingList, 
            hostAndUsername,
            savedUserToken,
            defaultProjectPath,
            departments,
            featuresConfig,
            status,
            commits,
            trigger
        }
    }
);